import { useEffect, useCallback } from 'react';
import { useAuthStore } from '@/store';
import { useTelegram } from './useTelegram';
import { authenticateTelegram, authenticateDev } from '@/services/api';

export function useAuth() {
  const {
    token,
    user,
    character,
    isAuthenticated,
    isLoading,
    setAuth,
    setCharacter,
    completeOnboarding,
    resetOnboarding,
    logout,
    setLoading,
  } = useAuthStore();
  
  const { isReady, isTelegramEnvironment, initData } = useTelegram();
  
  const authenticate = useCallback(async () => {
    if (!isReady) return;
    
    setLoading(true);
    
    try {
      let response;
      
      if (isTelegramEnvironment && initData) {
        // Авторизация через Telegram
        response = await authenticateTelegram();
      } else {
        // Dev-режим: создаём тестового пользователя
        const devTelegramId = Math.floor(Math.random() * 1000000000);
        response = await authenticateDev(devTelegramId, 'Dev User');
      }
      
      setAuth(response.token, response.user, response.character);
    } catch (error) {
      console.error('Authentication failed:', error);
      logout();
    }
  }, [isReady, isTelegramEnvironment, initData, setAuth, logout, setLoading]);
  
  // Автоматическая авторизация при загрузке
  useEffect(() => {
    if (isReady && !isAuthenticated) {
      authenticate();
    } else if (isReady && isAuthenticated) {
      setLoading(false);
    }
  }, [isReady, isAuthenticated, token, authenticate, setLoading]);
  
  return {
    user,
    character,
    isAuthenticated,
    isLoading,
    authenticate,
    logout,
    setCharacter,
    completeOnboarding,
    resetOnboarding,
    needsOnboarding: isAuthenticated && !user?.onboardingCompleted,
    hasCharacter: !!character,
  };
}
